import React from 'react'
import styled from 'styled-components';


function Subtitulo({children,backgroundColor, color}) {
  return (
    <Wrapper backgroundColor={backgroundColor}>
      <Content className='animate__animated animate__fadeInLeft'backgroundColor={backgroundColor} color={color}>{children}</Content>
    </Wrapper>
  )
}

export default Subtitulo

const Wrapper = styled.div`
    width:100%;
    background-color: ${props=> props.backgroundColor ? props.backgroundColor : 'var(--color-morado-oscuro)'};
`;

const Content = styled.h2`
    text-align:left;
    color: ${props=> props.color ? props.color : 'var(--color-blanco)'};
    padding: 32px 24px ;
    background-color: ${props=> props.backgroundColor ? props.backgroundColor : 'var(--color-morado-oscuro)'};
`;